import type {
  Border,
  Color,
  Size,
  BoxShadowLayer,
  TextShadow,
} from './adapters/styleApi';
import type { IconCssVars } from './sections/IconDesign/types';

export const DEBOUNCE_TIME = 200;

export const DefaultColors = {
  Black: {
    propertyType: 'Color',
    value: '#000000',
  },
  Transparent: {
    propertyType: 'Color',
    value: 'transparent',
  },
} as const satisfies Record<string, Color>;

export const DefaultSizes = {
  ZeroPixels: {
    propertyType: 'Size',
    value: 0,
    unit: 'px',
  },
} as const satisfies Record<string, Size>;

const DefaultBorder: Border = {
  propertyType: 'Border',
  size: DefaultSizes.ZeroPixels,
  style: 'solid',
  color: DefaultColors.Black,
};

const DefaultBoxShadowLayer: BoxShadowLayer = {
  propertyType: 'BoxShadowLayer',
  inset: false,
  offsetX: {
    propertyType: 'Size',
    value: 1,
    unit: 'px',
  },
  offsetY: {
    propertyType: 'Size',
    value: 1,
    unit: 'px',
  },
  blurRadius: {
    propertyType: 'Size',
    value: 4,
    unit: 'px',
  },
  spreadRadius: {
    propertyType: 'Size',
    value: 0,
    unit: 'px',
  },
  color: {
    propertyType: 'Color',
    value: '#00000099',
  },
};

const DefaultIcon: IconCssVars = {
  iconSize: DefaultSizes.ZeroPixels,
  iconColor: DefaultColors.Black,
  iconRotation: {
    propertyType: 'Transform',
    transformations: [
      {
        function: 'Rotate',
        value: 0,
        unit: 'deg',
      },
    ],
  },
};

const DefaultTextShadow: TextShadow = {
  propertyType: 'TextShadow',
  offsetX: {
    propertyType: 'Size',
    value: 2.83,
    unit: 'px',
  },
  offsetY: {
    propertyType: 'Size',
    value: 2.83,
    unit: 'px',
  },
  blurRadius: {
    propertyType: 'Size',
    value: 2,
    unit: 'px',
  },
  color: {
    propertyType: 'Color',
    value: '#000000',
  },
};

export const DefaultValues = {
  Size: DefaultSizes.ZeroPixels,
  Border: DefaultBorder,
  Icon: DefaultIcon,
  BoxShadowLayer: DefaultBoxShadowLayer,
  TextShadow: DefaultTextShadow,
} as const;
